import { Button } from '@mui/material';
import { SwipableDialog } from '@tix-ticketing/ui-components';
import { TicketsAlertIcon } from '@tix-ticketing/ui-icons/feature';
import { FormattedMessage, useIntl } from 'react-intl';

/** TODO(NEWBUY-1069): remove when backend supports adding extras
 *  Shown when something is added to the order while a ticket change is in
 *  progress. Offers the two ways forward: finish the change, or drop it and let
 *  the new tickets or items go into an order of their own. */
export const ExchangeAddBlockedDialog = ({
  open,
  onClose,
  onContinueExchange,
  onCancelExchange
}: {
  open: boolean;
  onClose: () => void;
  onContinueExchange: () => void;
  onCancelExchange: () => void;
}) => {
  const intl = useIntl();
  return <SwipableDialog open={open} onClose={onClose} maxWidth="md" headerIcon={<TicketsAlertIcon />} headerText={intl.formatMessage({
    id: "changeTickets.addBlocked.title",
    defaultMessage: [{
      "type": 0,
      "value": "Finish your ticket change first"
    }]
  })} subtitleText={intl.formatMessage({
    id: "changeTickets.addBlocked.description",
    defaultMessage: [{
      "type": 0,
      "value": "You can't add anything else to your order while you're changing tickets. Finish the change first, or cancel it and start a new order instead."
    }]
  })} primaryActionButton={<Button data-testid="exchange-add-blocked-continue-button" variant="contained" color="primary" size="large" fullWidth onClick={onContinueExchange}>
          <FormattedMessage id="changeTickets.addBlocked.continue" defaultMessage={[{
      "type": 0,
      "value": "Continue the change"
    }]} />
        </Button>} secondaryActionButton={<Button data-testid="exchange-add-blocked-cancel-button" variant="contained" color="monochrome" size="large" fullWidth onClick={onCancelExchange}>
          <FormattedMessage id="changeTickets.addBlocked.cancel" defaultMessage={[{
      "type": 0,
      "value": "Cancel the change"
    }]} />
        </Button>} />;
};